module.exports = __webpack_public_path__ + "img/zydx-banner.f35b9217.png";